import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MuiDialogContent from '@mui/material/DialogContent';
/**
 * A simple wrapper for the content of the Dialog, which adds correct padding and
 * allows for listening to scroll actions for use with the `scrollable` and
 * `scrolledToBottom` props on the dialog buttons
 */
export const DialogContent = ({ isScrollable, onScroll, children, ref, }) => {
    return (_jsx(MuiDialogContent, { ref: ref, onScroll: onScroll, sx: {
            paddingX: 6,
            paddingY: isScrollable ? 6 : 0,
        }, children: children }));
};
